import { __assign } from 'tslib';
import React__default, { forwardRef } from 'react';
import clsx from 'clsx';
import { useDropzone } from '../providers/upload/hooks/useDropzone.js';
import StyledUpload from './index.styled.js';

var Upload = forwardRef(function Upload(_a, _) {
    var uploadKey = _a.uploadKey, enable = _a.enable, className = _a.className, style = _a.style, sx = _a.sx, children = _a.children;
    var _b = useDropzone(uploadKey, enable), dropzoneRef = _b.dropzoneRef, openUploadDialogButtonRef = _b.openUploadDialogButtonRef;
    return (React__default.createElement(StyledUpload, { ref: dropzoneRef, className: clsx("Upload", className), style: style, sx: __assign(__assign({}, sx), { width: 1, height: 1 }), component: "aside" },
        React__default.createElement("button", { style: { display: "none" }, ref: openUploadDialogButtonRef }),
        children));
});

export { Upload };
//# sourceMappingURL=index.js.map
